import { put, post, get, del } from "@utils/axios";

const api = "clinics-management/clinics";

export const getClinicsReq = () => {
  return get(`${api}`);
}

export const createClinicReq = (payload) => {
  return post(`${api}`, payload);
}

export const deleteClinicReq = (id) => {
  return del(`${api}/${id}`);
}

export const updateClinicReq = (payload) => {
  return put(`${api}/${payload.object.id}`, payload);
}

export const changeStatusReq = (payload) => {
  return post(`${api}-status`, payload);
}

export const getClinicPermissionsReq = (id) => {
  return get(`user-management/Clinic-permissions/${id}`);
}

export const getClinicsPermissionReq = () => {
  return get(`/module-permissions`);
}

export const storePermissionsReq = (payload) => {
  return post(`/user-management/Clinic-permissions`, payload);
}